<template>
  <div>
    <b-modal v-model="modalActive" width="50%" scroll="keep">
      <div class="card">
        <header class="card-header ">
          <div class="card-header-title is-flex">
            <h6 class="is-size-6 ml-auto mr-auto pl-4 has-text-weight-semibold">{{ title }}</h6>
          </div>
          <b-button class="card-header-icon mt-2 mr-2" aria-label="more options" @click="show(false, false, false)">
            <b-icon icon="close"></b-icon>
          </b-button>
        </header>
        <div class="card-content" style="height: 500px">
          <div class="content" v-if="data">

            <div class="m-0 p-0 pr-2 pl-0">
              <div class="is-size-7 has-text-grey-light mt-1">Site Name</div>
              <div class="mt-0 has-text-weight-semibold">{{ data.name }}</div>
            </div>

            <div class="mt-5">
            <b-field v-for="(stage, index) in availableStages" :key="index">
              <b-checkbox v-model="selectedStages" :native-value="stage">
                {{ stage }}
              </b-checkbox>
            </b-field>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <b-button class="is-primary is-fullwidth m-2"  :disabled="selectedStages === null || selectedStages.length === 0" @click="onSaveClicked" rounded>Update Stages
          </b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {isProcessingEditOrAddAllowed} from "@/utils/helper";
import {nextTick} from "vue";

export default {
  name: "stages-modal",
  data() {
    return {
      isLoading: false,
      modalActive: false,
      data: null,
      title: null,
      selectedStages:[],
      availableStages: []
    }
  },
  mounted() {
    this.selectedStages = []
  },
  methods: {
    show(show, data, title) {
      console.log("Data: ", data)
      this.data = data
      this.title = title
      this.availableStages = this.getAvailableNames()
      this.selectedStages = this.getSelectedStageNames()
      this.modalActive = show
    },
    onSaveClicked(){
      console.log('On update stages')
      let payload = {
        id: this.data._id,
        surveyDetails: JSON.parse(JSON.stringify(this.data.surveyDetails))
      }

      payload.surveyDetails.selectedStageNames = this.selectedStages
      this.$emit('onUpdateStages', {payload: payload})
    },
    getAvailableNames(){
      if(this.data && this.data.siteConfiguration && this.data.siteConfiguration.stageConfig && this.data.siteConfiguration.stageConfig.length > 0){
        return [...new Set(this.data.siteConfiguration.stageConfig.map(item => item.veh))]
      }
      return []
    },
    getSelectedStageNames(){
      if(this.data && this.data.surveyDetails && this.data.surveyDetails.selectedStageNames && this.data.surveyDetails.selectedStageNames.length > 0){
        return this.data.surveyDetails.selectedStageNames
      }
      return []
    },
  }
}
</script>

<style scoped lang="scss">
</style>